import React from 'react'
import { Badge, BadgeProps, OverlayTrigger, Tooltip } from 'react-bootstrap'
import ConditionalWrap from 'conditional-wrap'
import { uniqueId } from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCamera } from '@fortawesome/free-solid-svg-icons'

import { OfferType } from '@monorepo/interfaces'
import { LightBox } from 'packages/components/common'

type PhotoInfoProps = BadgeProps & {
  item: OfferType
  tooltip?: React.ReactNode
}

export const PhotoInfo: React.FC<PhotoInfoProps> = ({
  item,
  tooltip,
  ...props
}) => {
  const isShow = Array.isArray(item.images) && item.images.length > 0

  return isShow ? (
    <LightBox images={item.images!}>
      <ConditionalWrap
        condition={tooltip}
        wrap={(children: any) => (
          <OverlayTrigger
            overlay={(props) => (
              <Tooltip {...props} id={uniqueId('tooltip-')}>
                {tooltip}
              </Tooltip>
            )}
          >
            {children}
          </OverlayTrigger>
        )}
      >
        <Badge {...props}>
          <FontAwesomeIcon icon={faCamera} />
        </Badge>
      </ConditionalWrap>
    </LightBox>
  ) : null
}
